module.exports = __webpack_public_path__ + "img/award-content-en.43896cb3.png";